
import marked from '@/mixins/marked'

export default {
  props: ['text', 'size'],
  mixins: [marked],
};
